// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 888) return "888.chunck.202407190717_4670448.js";
	if (chunkId === 134) return "134.chunck.202407190717_4670448.js";
	if (chunkId === 206) return "206.chunck.202407190717_4670448.js";
	if (chunkId === 687) return "687.chunck.202407190717_4670448.js";
	if (chunkId === 297) return "297.chunck.202407190717_4670448.js";
	if (chunkId === 664) return "664.chunck.202407190717_4670448.js";
	// return url for filenames based on template
	return undefined;
};